import { useEffect, useState } from 'react'
import * as Loader from 'react-loader-spinner'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Button } from '@imedcl/design-system'
import { SplitByCommaElement } from '../../helpers'
import { onlyDashRut } from '@imedcl/valida-rut'

export default function ModalContent() {
  const HOST_BACKEDN_PFP =
    process.env.REACT_APP_PFP_BACKEND || window._env_.REACT_APP_PFP_BACKEND
  const APIKEY_PRE =
    process.env.REACT_APP_APIKEY_PRE || window._env_.REACT_APP_APIKEY_PRE
  const navigate = useNavigate()
  const location = useLocation()
  const json = location.state
  axios.defaults.headers.common['apikey'] = `${APIKEY_PRE}`
  const [loading, setLoading] = useState(true)
  const [message, setMessage] = useState('')
  const [link, setLink] = useState('')

  //Esta es la funcion que creara un ticket con qbiz y redireccionara la url de pago.
  useEffect(() => {
    ;(async () => {
      try {
        //Validamos el token de sesión.
        let sessionActive = localStorage.getItem('session')
        if (!sessionActive) {
          navigate('/')
        }
        //obtenemos el ticket.
        const getTicket = await axios.post(
          `${HOST_BACKEDN_PFP}/v1/obtenerTicket`,
          json,
        )
        setLoading(false)
        if (parseInt(getTicket.data.status) === 200) {
          window.location.replace(getTicket.data.data.redirect)
        } else if (parseInt(getTicket.data.status) === 404) {
          setMessage(getTicket.data.message)
          setLink(getTicket.data.link)
        } else {
          navigate('/listDebts/disconnect')
        }
      } catch (error) {
        //direccionamos a otra modal de error.
        navigate('/listDebts/disconnect')
      }
    })()
  }, [])

  const returnListDeb = async () => {
    console.log(json.rut)
    await axios
      .get(`${HOST_BACKEDN_PFP}/v1/consultaDeuda?rut=${onlyDashRut(json.rut)}`)
      .then(function (response) {
        const jsonDebts = {
          status: 200,
          cantidad: response.data.cantidad,
          documentos: response.data.documentos,
          selectedRows: {},
        }
        navigate(-1, { state: jsonDebts })
      })
      .catch((e) => {
        navigate('/listDebts/disconnect')
      })
  }

  return (
    <>
      <div className='flex items-center justify-center mt-10'>
        <div
          className={`${
            message ? 'session-exists-width' : 'w-96'
          } mt-10 shadow-lg bg-white border-t-8 rounded border-info-dark`}>
          {loading ? (
            <>
              <h1 className='text-center text-2xl font-bold tracking-normal text-info-dark mt-10'>
                Cargando
              </h1>
              <div className='mt-5 text-center'>
                <Loader.TailSpin
                  wrapperClass='justify-center'
                  color='#3183F2'
                />
              </div>
              <br></br>
              <br></br>
            </>
          ) : !message ? (
            <>
              <h1 className='text-center text-2xl font-bold tracking-normal text-info-dark mt-10'>
                Iniciando Medpay
              </h1>
              <div className='mt-5 text-center'>
                <Loader.TailSpin
                  wrapperClass='justify-center'
                  color='#3183F2'
                />
              </div>
              <br></br>
              <br></br>
            </>
          ) : (
            <div className='session-exists'>
              {message.includes(
                'Hemos detectado un posible pago duplicado en los siguientes folios de factura:',
              ) ? (
                <div>
                  <h1 className='tracking-normal text-info-dark mt-10'>
                    <p className='text-xl font-bold'>Estimado Cliente,</p>
                    <br></br>
                    <p />
                    <p className='text-xl'>{message}</p>
                  </h1>
                  <h2 className='text-center font-semibold text-xl text-info-dark mt-5'>
                    <div className='mt-4'>
                      <SplitByCommaElement text={link} />
                    </div>
                  </h2>
                </div>
              ) : (
                <h1 className='text-center text-2xl font-bold tracking-normal text-info-dark mt-10'>
                  {message}
                </h1>
              )}
              <div className='flex items-center justify-center gap-buttons-session-actions mt-10 mb-10'>
                <Button
                  className='text-center'
                  size='m'
                  type='secondary-two'
                  onClick={returnListDeb}>
                  Volver
                </Button>
                {!message.includes(
                  'Hemos detectado un posible pago duplicado en los siguientes folios de factura:',
                ) && (
                  <Button
                    className='text-center'
                    size='m'
                    type='secondary'
                    onClick={() => window.location.replace(link)}>
                    Ir al pago
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
